import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { BehaviorSubject, Subject } from 'rxjs';
import { ThrowStmt } from '@angular/compiler';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  searchResults = new Subject<any>();
  private patientProfile = new Subject<any>();
  patientInProfile = this.patientProfile.asObservable();
  searchNow = new Subject<any>();
  constructor() { }

  search(criteria: string) {
    let i = 0;
    const values = ['FirstName', 'LastName', 'LegalCaseId', 'caseName', 'DateOfBirth', 'fileSearchQuery'];
    this.searchNow.subscribe((querySnapshot) => {
      if (querySnapshot.docs.length > 0) {
        this.searchResults.next(querySnapshot);
      } else if (i < values.length) {
        i++;
        this.searchByValue(values[i], criteria.toString());
      }
    });
    this.searchByValue(values[i], criteria.toString());
  }
  searchByValue(value: string, criteria: string): any {
    if (value === 'FirstName' || value === 'LastName') {
      criteria = criteria.toLowerCase();
    }

    if (value === 'fileSearchQuery') {
      firebase.firestore().collection('patients').where(value, 'array-contains', criteria).get().then((querySnapshot) => {
        this.searchNow.next(querySnapshot);
      });
    } else {
      firebase.firestore().collection('patients').where(value, '==', criteria).get().then((querySnapshot) => {
        this.searchNow.next(querySnapshot);
      });
    }
  }

  getPatienIdByCaseName(caseName: string) {
    firebase.firestore().collection('patients').doc(caseName).onSnapshot((doc) => {
      this.patientProfile.next(doc);
    });
  }
}
